import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { PathName } from "../constants/PathName";
import useQueryParams from "../hooks/useQueryParams";
import { LocalStorageKeys } from "../constants/LocalStorageKeys";

type Status = "pending" | "success" | "error";

// You can't use capacitor here
// This only works with the mcd login web view (coming back from eID login) and not with ionic portal web view (tkit and oadt)
const McdCallback = () => {
	const queryParams = useQueryParams();
	const history = useHistory();

	const isFinished = useRef(false);
	const [status, setStatus] = useState<Status>("pending");
	const [errorMsg, setErrorMsg] = useState("");

	useEffect(() => {
		// isFinished prevents multiple calls
		// not sure why it fires multiple times
		if (isFinished.current) return;
		isFinished.current = true;

		const token = queryParams.get("token");
		const error = queryParams.get("error");
		const errorDescription = queryParams.get("error_description");

		if (error) {
			// Native bridge has no error channel today — fail closed by not calling it.
			setErrorMsg(errorDescription || error);
			setStatus("error");
			return;
		}

		if (token) {
			if ((window as any).Native) {
				// android
				(window as any).Native.finish(token);
			} else if ((window as any).webkit?.messageHandlers?.["Native"]) {
				// ios
				(window as any).webkit.messageHandlers["Native"].postMessage(token);
			} else {
				// web
				localStorage.setItem(LocalStorageKeys.TOKEN, token);
				history.push(PathName.DASHBOARD);
			}
			setStatus("success");
			return;
		}

		setErrorMsg("Login did not complete. Please try again.");
		setStatus("error");
	}, [queryParams]);

	if (status === "error") {
		return (
			<div style={{ padding: "2rem", textAlign: "center" }}>
				<div className="errorMsg" style={{ marginBottom: "1rem" }}>
					{errorMsg}
				</div>
				<button
					type="button"
					onClick={() => history.push(PathName.LOGIN)}
					style={{ padding: "0.5rem 1rem", cursor: "pointer" }}
				>
					Try again
				</button>
			</div>
		);
	}

	return <div>Logging in...{/* @TODO loading anim would be nice here */}</div>;
};

export default McdCallback;
